// What this browser remembers for the player: the slip's pace, how the wire is sorted and which
// beats it shows. Each read and write survives storage that is blocked or empty.

import { createStore, useStore } from "./store";

export type Prefs = {
  /** Leverage last used, by key. */
  leverage: Record<string, number>;
  wireSort: "heat" | "latest";
  /** Beats hidden from the wire and the globe. */
  muted: string[];
  /** Chips, the bell and the bust: the table's sounds. */
  sound: boolean;
};

const KEY = "hypa:prefs:v1";
const DEFAULTS: Prefs = { leverage: {}, wireSort: "heat", muted: [], sound: true };

function read(): Prefs {
  try {
    const text = localStorage.getItem(KEY);
    return text ? { ...DEFAULTS, ...(JSON.parse(text) as Partial<Prefs>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export const prefs = createStore<Prefs>(read());

prefs.subscribe(() => {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs.get()));
  } catch {
    // storage blocked: kept for this tab
  }
});

export function setPref<K extends keyof Prefs>(key: K, value: Prefs[K]) {
  prefs.set((all) => ({ ...all, [key]: value }));
}

export function usePref<K extends keyof Prefs>(key: K): Prefs[K] {
  return useStore(prefs, (all) => all[key]);
}
